import React, { useEffect } from "react";

import { CommonProps } from "@utils/interface";
import { useOnload } from "@utils/useRunOnload";
import { DottedLine, ExtraBenefitsContainer, ExtraBenefitsItem, ImageContainer, PlansCoverageDetails, PlansCoveragePoints, PlansDetailsWrapper } from "./styles";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import { LearnMore } from "@components/addonUpgradeCard/styles";

interface PlansDetailsInterface extends CommonProps {
    coverageDetails: any;
    extraBenefits: any;
    bonusCoveragePoint?: string;
}

const PlansDetails = ({ children, ...props }: PlansDetailsInterface) => {
    const { actions, id } = props;
    const { on_load, on_click } = actions || {};
    const { coverageDetails, extraBenefits, bonusCoveragePoint } = props
    const coveragePoints = bonusCoveragePoint
        ? [...(coverageDetails?.coverageDetailsList || []).filter((point: string) => !/free consumables cover|rat.bite/i.test(point)), bonusCoveragePoint]
        : coverageDetails?.coverageDetailsList;

    useOnload({ id, on_load });

    const onPlanDetails = () => {
        if (on_click?.length > 0) {
            on_click?.forEach((eachFunc: any) => {
                typeof eachFunc.funCall === "function" &&
                    eachFunc.funCall({
                        ...eachFunc.args,
                    });
            });
        }
    }
    return (
        <PlansDetailsWrapper>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px" }}>
            <PlansCoverageDetails>
                <span style={{ marginRight: "4px" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <path d="M4.86293 9.83067C4.2891 7.81701 2.19115 5.7269 0.169956 5.1552C-0.056652 5.08237 -0.056652 4.92216 0.169956 4.84569C2.1948 4.27036 4.2891 2.18388 4.86658 0.166591C4.92872 -0.0555302 5.07857 -0.0555302 5.14071 0.166591C5.71453 2.18388 7.81248 4.27036 9.83004 4.84569C10.0567 4.91852 10.0567 5.08237 9.83004 5.1552C7.80882 5.7269 5.71087 7.81701 5.13705 9.83067C5.07491 10.0564 4.92506 10.0564 4.86293 9.83067Z" fill="#451999" />
                    </svg>
                </span>
                {coverageDetails?.coverageDetailsTitle}
            </PlansCoverageDetails>
                <LearnMore onClick={onPlanDetails}>Learn more</LearnMore>
            </div>
            <div style={{ marginBottom: "20px" }}></div>
            {
                coveragePoints?.map((point: string, index: number) => (
                    <Flex key={index} alignItems="start" margin="0 0 8px 0">
                        <div style={{ marginRight: "8px" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.82667 1C3.16097 1 1 3.16097 1 5.82667C1 8.49236 3.16097 10.6533 5.82667 10.6533C8.49236 10.6533 10.6533 8.49236 10.6533 5.82667C10.6533 3.16097 8.49236 1 5.82667 1ZM0 5.82667C0 2.60869 2.60869 0 5.82667 0C9.04464 0 11.6533 2.60869 11.6533 5.82667C11.6533 9.04464 9.04464 11.6533 5.82667 11.6533C2.60869 11.6533 0 9.04464 0 5.82667Z" fill="#36354C" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.14607 4.26693C8.34133 4.46219 8.34133 4.77877 8.14607 4.97403L5.36306 7.75704C5.26163 7.85847 5.09717 7.85847 4.99574 7.75704L3.51273 6.27403C3.31747 6.07877 3.31747 5.76219 3.51273 5.56693C3.708 5.37166 4.02458 5.37166 4.21984 5.56693L5.1794 6.52649L7.43896 4.26693C7.63422 4.07166 7.9508 4.07166 8.14607 4.26693Z" fill="#36354C" />
                            </svg>
                        </div>
                        <PlansCoveragePoints dangerouslySetInnerHTML={{ __html: point }}></PlansCoveragePoints>
                    </Flex>
                ))
            }

            {
                extraBenefits?.extraBenefitsList && extraBenefits?.extraBenefitsList.length > 0 ? (
                    <>
                        <DottedLine />
                        <PlansCoverageDetails>
                            <span style={{ marginRight: "4px" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                    <path d="M4.86293 9.83067C4.2891 7.81701 2.19115 5.7269 0.169956 5.1552C-0.056652 5.08237 -0.056652 4.92216 0.169956 4.84569C2.1948 4.27036 4.2891 2.18388 4.86658 0.166591C4.92872 -0.0555302 5.07857 -0.0555302 5.14071 0.166591C5.71453 2.18388 7.81248 4.27036 9.83004 4.84569C10.0567 4.91852 10.0567 5.08237 9.83004 5.1552C7.80882 5.7269 5.71087 7.81701 5.13705 9.83067C5.07491 10.0564 4.92506 10.0564 4.86293 9.83067Z" fill="#451999" />
                                </svg>
                            </span>
                            {extraBenefits?.extraBenefitsTitle}
                        </PlansCoverageDetails>
                        <Flex flexDirection="row" justifyContent="center" alignItems="center">
                            <ExtraBenefitsContainer>
                                {
                                    extraBenefits?.extraBenefitsList?.filter(point => point.is_selected)?.map((point, index: number) => (
                                        <ExtraBenefitsItem>
                                            <ImageContainer>
                                                <img src={point?.image} alt={`Coverage detail ${index}`} style={{ height: "24px", width: "24px" }} />
                                            </ImageContainer>
                                            {point?.description && <PlansCoveragePoints>
                                                <p dangerouslySetInnerHTML={{ __html: point?.display_name || "" }}></p>
                                            </PlansCoveragePoints>}
                                        </ExtraBenefitsItem>
                                    ))
                                }
                            </ExtraBenefitsContainer>
                        </Flex>
                    </>
                ) : null
            }
            {children}
        </PlansDetailsWrapper >
    );
};

export default PlansDetails;
